import type { ThemeConfig } from "@/lib/types"

/**
 * Whether this tenant asks customers for their date of birth.
 *
 * The date of birth is collected for the loyalty birthday gift, so `loyalty`
 * is the correct default: a tenant without a loyalty programme has no purpose
 * for the data (GDPR data minimisation), and the field's helper copy promises
 * a birthday treat that would never arrive. The explicit `features.dateOfBirth`
 * flag is the escape hatch for a future tenant that needs a birth date for
 * another lawful reason (e.g. age-restricted goods) without enabling loyalty.
 *
 * Pure and synchronous, so both Client Components (useThemeContext()) and RSCs
 * (getThemeConfig()) can call it. It answers the question for the CALLER only
 * — it renders nothing and persists nothing; each form decides what to do with
 * the answer.
 */
export function collectsDateOfBirth(config: ThemeConfig): boolean {
  return config.features.dateOfBirth ?? config.features.loyalty
}
